import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { TabsSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import { useSelector } from 'react-redux';
import BsEmbeddedMoistureConditionValueWorksheet from '../../../../C13_4/BsEmbeddedMoistureConditionValueWorksheet';
import MoistureConditionValueResultsSection from './MoistureConditionValueResultsSection';

let MoistureConditionValueTabsSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const tests = useSelector(createWorksheetSelector!('EmbeddedTests.Tests')) as any[];

  return (
    <TabsSection
      data={[
        ...tests.map((_, index) => ({
          menuItem: `Test ${index + 1}`,
          render: () => (
            <NamePrefixModifier appendNamePrefix={`EmbeddedTests.Tests[${index}].Data`}>
              <BsEmbeddedMoistureConditionValueWorksheet />
            </NamePrefixModifier>
          ),
        })),
        { menuItem: 'Results', render: () => <MoistureConditionValueResultsSection /> },
      ]}
    ></TabsSection>
  );
};

MoistureConditionValueTabsSection = withInjectedProps(MoistureConditionValueTabsSection);

export { MoistureConditionValueTabsSection };
export default MoistureConditionValueTabsSection;
